











import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Swiper, { SwiperOptions } from "swiper";
import "swiper/swiper.scss";
import SwiperOption from "./swiperOption";

@Component({})
export default class VueSwiper extends Vue {
  /* -------------- prop ------------- */
  @Prop({ default: 1 }) slidesPerView?: number | string; // 设置slider容器能够同时显示的slides数量
  @Prop({ default: 0 }) spaceBetween?: number; // 在slide之间设置距离（单位px）
  @Prop({ default: false }) loop?: boolean; // 是否启用loop模式
  @Prop({ default: true }) centeredSlides?: boolean; // 设定为true时，active slide会居中，而不是默认状态下的居左
  @Prop({ default: false }) autoplay?: boolean; // 是否开启自动播放
  @Prop({ default: 3000 }) delay?: number; // 自动切换的时间间隔，单位ms
  @Prop({ default: false }) disableOnInteraction?: boolean; // 用户操作swiper之后，是否禁止autoplay

  /* -------------- Model ------------- */

  /* -------------- data ------------- */
  $refs!: {
    wrapper: HTMLFormElement;
    container: HTMLFormElement;
  };

  swiper?: Swiper;
  realIndex = 0; // 当前活动块的索引

  /* -------------- computed ------------- */

  /* -------------- watch ------------- */
  @Watch("realIndex")
  onChangeRealIndex (val: number) {
    this.$emit("update:realIndex", val);
  }

  /* -------------- hook ------------- */
  mounted () {
    this.initSwiper();
  }

  beforeDestroy () {
    this.destroySwiper();
  }

  /* -------------- methods ------------- */
  initSwiper () {
    // 如果已经有swiper实例了,就先销毁
    this.destroySwiper();
    this.$nextTick(() => {
      this.createSwiper();
    });
  }

  createSwiper () {
    // 创建swiper

    // 轮播内容的class必须为swiper-slide
    const slides = this.$refs.wrapper.children;
    Array.from(slides).forEach(el => {
      el.classList.add("swiper-slide");
    });

    // swiper 配置参数
    const option: SwiperOption = {
      slidesPerView: this.slidesPerView,
      spaceBetween: this.spaceBetween,
      loop: this.loop,
      centeredSlides: this.centeredSlides,
      on: {
        // swiper从一个slide过渡到另一个slide结束时执行
        slideChangeTransitionEnd: () => {
          if (this.swiper !== undefined) {
            this.realIndex = this.swiper.realIndex;
          }
        }
      }
    };

    // 自动播放
    if (this.autoplay) {
      option.autoplay = {
        delay: this.delay,
        disableOnInteraction: this.disableOnInteraction
      };
    }
    // 创建swiper
    this.swiper = new Swiper(this.$refs.container, option as SwiperOptions);
  }

  destroySwiper () {
    // 销毁swiper
    if (this.swiper !== undefined) {
      this.swiper.destroy(true, false);
      this.swiper = undefined;
    }
  }

  slidePre () {
    // 向前滑动
    if (this.swiper !== undefined) {
      this.swiper.slidePrev();
    }
  }

  slideNext () {
    // 向后滑动
    if (this.swiper !== undefined) {
      this.swiper.slideNext();
    }
  }

  slideTo (index: number) {
    if (this.swiper !== undefined) {
      this.swiper.slideTo(index);
    }
  }

  update () {
    // 更新swiper
    this.initSwiper();
  }
}
